import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import { useDialogContext } from "../HubDialogWrapper";
import { HubButton, HubDialogContent } from "../../components";

import SerializationContentForm from "./SerializationContentForm";

const SerializationContent = () => {
  const { open: index, onClose = () => {} } = useDialogContext();

  const fieldArrayOptions = useFieldArray({
    name: `workOrders.${index}.serialization`,
  });

  return (
    <HubDialogContent largePadding>
      <Stack gap="35px">
        <Stack gap="10px" alignItems="center">
          <Typography variant="h6">Serialize Box Work Order</Typography>
          <Typography
            variant="caption"
            sx={{ textAlign: "center", maxWidth: "450px" }}
          >
            Scan all barcodes for the Work Order:
          </Typography>
        </Stack>
        <SerializationContentForm {...fieldArrayOptions} />
        <HubButton
          label="Close Serialization"
          variant="contained"
          color="grey"
          size="xsmall"
          onClick={onClose}
        />
      </Stack>
    </HubDialogContent>
  );
};

export default SerializationContent;
